import React from 'react';
import FormEdit from '../../../components/common/Forms/FormEdit';

/**
 * MatFormEdit - Page wrapper for editing filled Material Control forms
 * Used for navigation in routes/index.tsx
 */
const MatFormEdit: React.FC = () => {
  return <FormEdit />;
};

export default MatFormEdit;
